module.exports = __webpack_public_path__ + "static/media/caret-up-white.3c2c42ea.svg";